import { render, staticRenderFns } from "./SystemFlags.vue?vue&type=template&id=18c093f8&scoped=true"
import script from "./SystemFlags.vue?vue&type=script&lang=js"
export * from "./SystemFlags.vue?vue&type=script&lang=js"
import style0 from "./SystemFlags.vue?vue&type=style&index=0&id=18c093f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c093f8",
  null
  
)

export default component.exports